module.exports = __webpack_public_path__ + "img/pilates.369aae65.jpg";